


























import { Component, Vue } from 'vue-property-decorator';

// Services
import Auth from '@/services/Auth';
import LatestNews from '@/services/LatestNews';
import * as Sentry from '@sentry/browser';

// Components
import Loading from '@/components/Global/Loading.vue';

@Component({
	name: 'Balance',
	components: {
		Loading,
	},
})
export default class LatestNewsWidget extends Vue {
	private Auth: any;
	private loading: boolean;
	private error: boolean;

	constructor() {
		super();
		this.Auth = Auth;
		this.loading = true;
		this.error = false;
	}

	get news() {
		return this.$store.getters['LatestNews/news'];
	}

	private async created() {
		try {
			await this.$store.dispatch('LatestNews/getLatestNews', {});
		} catch (e) {
			Sentry.captureException(e);
		} finally {
			this.loading = false;
		}
	}
}
